module.exports = __webpack_public_path__ + "media/images/icons/facebook_blue-a4a2a6b7d6c0cff42757f7ad8c9e78c8.svg";